import { render, staticRenderFns } from "./PatOTPPage.vue?vue&type=template&id=afdfa3d0"
import script from "./PatOTPPage.vue?vue&type=script&lang=js"
export * from "./PatOTPPage.vue?vue&type=script&lang=js"
import style0 from "./PatOTPPage.vue?vue&type=style&index=0&id=afdfa3d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports